import api from "./client";

export const getSiteSummary = async (siteId) => {
  const { data } = await api.get(`/sites/${siteId}/summary`);
  return data;
};

export const getArrayInverterSummary = async (siteId) => {
  const { data } = await api.get(`/sites/${siteId}/array_inverter_summary`);
  return data;
};
